import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import Packages from "@/components/Packages";
import Testimonials from "@/components/Testimonials";
import Countdown from "@/components/Countdown";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

const API_BASE = process.env.REACT_APP_API_URL || "/api/index.php";

export const Landing = () => {
  useEffect(() => {
    // Catat kunjungan halaman untuk monitoring traffic — gagal diam-diam kalau offline
    fetch(`${API_BASE}?resource=track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        path: window.location.pathname,
        referrer: document.referrer || "",
      }),
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Packages />
        <Testimonials />
        <Countdown />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default Landing;
